import React, {ChangeEvent, useState} from 'react';
import {Modal} from '../Modal';
import {ActivityButton} from '../ActivityButton';
import {Field} from '../../types';
import {Flow, FlowFetchResponse} from '../../_services/Flow';
import {Etl} from '../../_services/Etl';
import {applyFillMap} from '../../_helpers/etl';

type NestedFormExcelUploadProps = {
    field: Field;
    dismiss: () => void;
    onUploadComplete: (data: object[], meta: any) => void;
};

export const NestedFormExcelUpload: React.FunctionComponent<NestedFormExcelUploadProps> = ({
                                                                                               field,
                                                                                               dismiss,
                                                                                               onUploadComplete
                                                                                           }): JSX.Element => {

    const [excelUploadFile, setExcelUploadFile] = useState();
    const [errorMessage, setErrorMessage] = useState<string>('');
    const [isWorking, setIsWorking] = useState<boolean>(false);

    const handleUpload = () => {
        if (!excelUploadFile) {
            setErrorMessage('You must select a file');
            return;
        }

        setIsWorking(true);
        setErrorMessage('');

        Flow.getInstance().nestedFormExcelUpload(field.formId, field.id, excelUploadFile)
            .then((response: FlowFetchResponse) => {
                if (response.ok && response?.json?.data && Array.isArray(response.json.data)) {
                    let validationErrorMessage = '';
                    if (response?.json?.rowsSkippedDueToValidation) {
                        validationErrorMessage = response.json.message || 'One or more rows skipped due to validation errors';
                    }
                    onUploadComplete(response.json.data, {errorMessage: validationErrorMessage});
                    dismiss();
                } else {
                    setErrorMessage(response?.json?.message || 'Error uploading file');
                }
                setIsWorking(false);
            })
            .catch((error: any) => {
                setIsWorking(false);
                setErrorMessage(error || 'Error uploading file');
            });
    };

    return (
        <Modal>
            <div className="modal-header">
                <h5 className="modal-title">Excel Template Upload</h5>
                <button type="button"
                        className="close"
                        aria-label="Close"
                        tabIndex={-1}
                        onClick={() => {
                            setExcelUploadFile(null);
                            dismiss();
                        }}
                >
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div className="modal-body">
                {/* field.flowCustomDisplayComponentConfig.excelUpload.uploadDialogText */}
                {errorMessage && <p className="alert alert-danger">{errorMessage.split(/\n/).map(l => <div>{l}</div>)}</p>}
                <p>Download the Excel template <a href={field.flowCustomDisplayComponentConfig.excelUpload.templateUrl}>here</a>. Fill out and upload in the field below. Click the <em>Upload</em> button to upload the file to the Workflow</p>
                <p><strong>Do not</strong> change the order of any of the fields.</p>
                <p><strong>Do not</strong> remove the header row</p>

                <div className="form-group">
                    <input type="file"
                           className="form-control-file"
                           onChange={(e: ChangeEvent<HTMLInputElement>) => {
                               e.target &&
                               e.target.files &&
                               e.target.files.length &&
                               setExcelUploadFile(e.target.files[0])
                           }}
                    />
                </div>

            </div>
            <div className="modal-footer">
                <button type="button"
                        className="btn btn-secondary"
                        onClick={() => {
                            setExcelUploadFile(null);
                            dismiss();
                        }}
                >Cancel
                </button>
                <ActivityButton
                    isActive={isWorking}
                    className="btn btn-primary"
                    onClick={() => {
                        handleUpload();
                    }}
                >
                    Upload
                </ActivityButton>
            </div>
        </Modal>
    );
};